import { IdName } from '@api/models/idname';
import { TimeframeEnum } from '@api/index';
import { DeviceType } from '@shared/models/enums/deviceType.enum';

export interface BookingPageExposureDetails {
  customer: IdName;
  channels: IdName[];
  screens: IdName[];
  engagementType: number;
  booking: BookingChildExtendedDetails;
  placements: IdName[];
  startDate?: string;
  endDate?: string;
  timeframe?: TimeframeEnum;
}

export interface Advertisement {
  advertisementDetails: AdvertisementDetail[];
  presentationTime: number;
  bookedScreens: BookedScreen[];
}

export interface BookedScreen {
  name: string;
  type: DeviceType;
}

export interface AdvertisementDetail {
  id: number;
  mediaDetails: MediaPlaylistDetails;
  presentationTime: number;
  orderId: number;
  triggers: any | null;
}

export interface MediaPlaylistDetails {
  mediaFileStreamingLink: string;
  mediaFileThumbnailStreamingLink: string;
  mediaId: number;
  name: string;
  filename: string;
  type: number;
  height: number;
  width: number;
  created: string;
  duration: number;
  blobContentHashCode: string | null;
}

export interface MarketingAutomation {
  marketingAutomationDetails: MarketingAutomationDetails;
  childPlaylistDetails: ChildPlaylistDetails;
}

export interface MarketingAutomationDetails {
  hasMarketingAutomation: boolean;
  hasAdvancedSettings: boolean;
  sensitivitySettings: number;
  sensitivitySettingsRules: any | null;
  marketingAutomationConfiguration: any | null;
}

export interface ChildPlaylistDetails {
  childPlaylist: IdName;
  presentationId: number;
  engagementSlots: EngagementSlot[];
  childPlaylistMediaFiles: ChildPlaylistMediaFile[];
}

export interface EngagementSlot {
  engagementSlotId: number;
  startDate: Date;
  endDate: Date;
  screen: IdName;
  channel: IdName;
}

export interface ChildPlaylistMediaFile {
  id: number;
  mediaDetails: MediaPlaylistDetails;
  presentationTime: number;
  orderId: number;
  triggers: MediaTriggers | null;
}

export interface MediaTriggers {
  weatherConditions: string[];
  temperature: number | null;
}

export interface BookingChildExtendedDetails{
  id: number;
  name: string;
  childPlaylistId: number | null;
  childPlaylistName: string | null;
}

export enum BookingLifecycleStatusEnum {    
  Upcoming = 1,
  Ongoing,
  Completed
}